"use strict";

angular.module("core").service("UserService", function($rootScope, $cookies, $http, $q, $state, bowser, appConfig) {
    var _this = this;
    var promises = [];

    function setAuthToken(token, appData) {
        var options = {};

        var expirationDaysDelta = 30;
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + expirationDaysDelta);
        options['expires'] = expirationDate

        if (appData && appData.allow_multiple_apps_access) {
            options['domain'] = appConfig.ROOT_DOMAIN;
            $cookies.put("allow_multiple_apps_access", appData.allow_multiple_apps_access, options);
        }

        $cookies.put("token", token, options);
    }

    this.refreshCurrentUser = function(updateCurrentNumbers) {
        var deferred = $q.defer();
        $http({
            method: "get",
            url: appConfig.API_SERVER + "/auth/" + appConfig.APP + "/myself/"
        }).then(function(response) {
            var user = response.data;

            if (user.info && user.info.is_impersonator && !user.vendor) {
                $rootScope.$broadcast("ImpersonatorUserUpdated", user);
            }
            else if (
                appConfig.APP === "customer"
                && !user.customer
                && (user.standard_user_customer_count > 1 || !!user.global_dedicated_vendor_id)
            ) {
                $rootScope.$broadcast("UserWithoutCustomerUpdated", user);
            }
            else {
                $rootScope.$broadcast("UserUpdated", user, updateCurrentNumbers);
            }
            $rootScope.user = user;
            deferred.resolve(user);
        }, function onError() {
            deferred.resolve(null);
        });
        promises.push(deferred.promise);
        return deferred.promise;
    };

    this.setAuthTokenAndUser = function(token, appData) {
        setAuthToken(token, appData);
        this.refreshCurrentUser();
    };

    this.persistAuthToken = function(tokenResponse) {
        this.setAuthTokenAndUser(tokenResponse.data.token, tokenResponse.data);
    };

    this.persistAuthTokenWithoutUserRefresh = function(tokenResponse) {
        setAuthToken(tokenResponse.data.token, tokenResponse.data);
    };

    this.isLoggedIn = function() {
        return !!$cookies.get("token");
    };

    this.clearTokenAndUser = function() {
        $cookies.remove("token");
        $cookies.remove("token", {
            domain: appConfig.ROOT_DOMAIN
        });
        $cookies.remove("allow_multiple_apps_access", {
            domain: appConfig.ROOT_DOMAIN
        });
        $rootScope.user = null;
        $rootScope.$broadcast("UserLoggedOut");
    };

    this.initUser = function() {
        if ($cookies.get("token")) {
            var appData = {
                "allow_multiple_apps_access": $cookies.get("allow_multiple_apps_access")
            }
            this.setAuthTokenAndUser($cookies.get("token"), appData);
        }
        else {
            this.logout();
        }
    };

    this.logoutAndRedirect = function(state, params) {
        var promise = this.logout();
        promise.then(function() {
            if (params === undefined) {
                params = {};
            }

            $state.go(state, params);
        });
    };

    this.logout = function() {
        if (this.isLoggedIn()) {
            return $http({
                method: "post",
                url: appConfig.API_SERVER + "/auth/logout/"
            }).then(function(response) {
                _this.clearTokenAndUser();
                $rootScope.toState = undefined;
                $rootScope.toParams = undefined;
            });
        }
        else {
            var deferred = $q.defer();
            deferred.resolve(null);
            return deferred.promise;
        }
    };

    this.setModified = function() {
        var _this = this;

        return $http({
            method: "POST",
            url: appConfig.API_SERVER + "/auth/modified/",
            data: {}
        }).then(function() {
            return _this.refreshCurrentUser();
        });
    };

    this.isUserFetched = function() {
        return $q.all(promises).then(function onSuccess() {
            return $rootScope.user;
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/user/user.service.js
// module id = 419
// module chunks = 0